const handleRolesChange = ({
  selectedFromCurrentProduct,
  currentOptions,
  selected,
  setSelected,
  formik,
  formikField,
}) => {
  const labelToIdMap = new Map();

  selectedFromCurrentProduct.forEach((roleId) => {
    const role = currentOptions.find((opt) => opt.value === roleId);
    if (role && !labelToIdMap.has(role.label)) {
      labelToIdMap.set(role.label, role.value);
    }
  });

  const deduplicatedCurrent = Array.from(labelToIdMap.values());
  const currentOptionIds = currentOptions.map((opt) => opt.value);

  const fromOtherProducts = selected.filter((roleId) => !currentOptionIds.includes(roleId));
  const finalSelection = [...fromOtherProducts, ...deduplicatedCurrent];

  formik.setFieldValue(formikField, finalSelection);
  setSelected(finalSelection);
};
export default handleRolesChange;
